/**
 * @description Creates a pill container for label/value pairs, where the label is displayed on the left and the value is displayed on the right.
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import Typography from '@mui/material/Typography';
import styled from '@mui/system/styled';

const PillContainer = styled(Typography)({
  display: 'inline-flex',
  flexWrap: 'nowrap',
  height: 'fit-content',
  lineHeight: 2,
  maxWidth: '100%'
});

const LabelContainer = styled(Typography)(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  borderBottomLeftRadius: 16,
  borderTopLeftRadius: 16,
  color: theme.palette.common.white,
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  paddingLeft: '0.75em',
  paddingRight: '0.5em',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textWrap: 'nowrap'
}));

const ValueContainer = styled(Typography)(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  borderBottomRightRadius: 16,
  borderTopRightRadius: 16,
  color: theme.palette.common.white,
  flex: 1,
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  paddingLeft: '0.5em',
  paddingRight: '0.75em',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textWrap: 'nowrap'
}));

const Pill = ({ children, label, ...otherProps }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <PillContainer {...otherProps}>
    <LabelContainer component='span'>
      {label}
    </LabelContainer>
    <ValueContainer component='span'>
      {children}
    </ValueContainer>
  </PillContainer>
);

Pill.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

Pill.defaultProps = {
  children: null
}

export default Pill;
